import request from "@/router/axios";

// 查询车辆出库明细列表
export const getList = (params) => {
  return request({
    url: "/api/produce/out-in-stock-record/select/page",
    method: "post",
    data: params,
  });
};

// 查询车辆出库明细详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/out-in-stock-record/select/id",
    method: "get",
    params: { id },
  });
};
